module.exports = __webpack_public_path__ + "images/file_icons_v2/exe-d9c793bf1af160f11ec9201cf575544a.svg";